@if (rangeText()) {
  <div class="date-range-text" [ngStyle]="mergedStylingInfo()" [title]="rangeText()">({{rangeText()}})</div>
}